import styled from 'styled-components'

export const QualityIndicatorIcon = styled.div`
  display: inline-block;
  border: 2px solid #6b6b6b;
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  border-radius: 0;

  &.circle {
    border-radius: 50%;
  }

  &.filled {
    background-color: #6b6b6b;
  }
`

export const QualityIndicatorCross = styled.span`
  display: inline-block;
  flex-shrink: 0;
  min-width: 112px;
  width: 144px;
  font-size: 16px;
  color: #6b6b6b;
  line-height: 16px;
  margin-bottom: 5px;
`

export const QualityIndicatorIconWrapper = styled.div`
  width: 122px;
  justify-content: space-between;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
`
